<template>
  <footer class="footer__wrapper">
    <div class="footer__container">
      <div class="footer__text">
        New site coming soon
      </div>
      <a
        href="/"
        class="footer__logo-wrapper"
      >
        <img
          src="/images/logo.svg"
          alt="logo"
          class="footer__logo"
        >
      </a>
      <div class="footer__text">
        All rights reserved. Yousquared {{ year }}
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'FooterComponent',
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>
<style
  lang="scss"
  scoped
>
  .footer {
    &__wrapper {
      width: 100%;
      background: $theme-color-accent;
      padding: 38px 0 15px;
    }

    &__container {
      max-width: 1400px;
      width: 100%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    &__text {
      text-align: center;
      color: $theme-color-light;
      font-size: 0.65em;
      font-family: Montserrat;
    }

    &__logo-wrapper {
      width: 197px;
      display: block;
      margin: 48px 0;
    }

    &__logo {
      max-width: 100%;
    }
  }
</style>
